import React from 'react';
import { Button, Card, DatePicker, Form, message, Spin, Select, Input, Icon, Switch, Tooltip } from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import { fetchEvt } from "../../redux/actions/evt";
import { findRollpools } from "../../services/luckydraw";
import { findLuckyMoneys } from "../../services/luckyMoney";
import { findSurveys, findVotes } from "../../services/questionnaire";
import { findBarrageConfigs } from "../../services/barrage";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import { patchEventConfig } from "../../services/evt";
import PurchaseServiceTips from "../PurchaseServiceTips";
import { isValidity } from "../../services/global";
import moment from 'moment';
import lodash from 'lodash'

const RangePicker = DatePicker.RangePicker;

const mapStateToPorps = state => {
    const loginedUser = state.loginedUser;
    const cmEnums = state.cmEnums;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewCheckinAction extends React.Component {
    constructor(props) {
        super(props);
        this.pstView = null;
        console.log(props)
        this.state = {
            validity: false,
            formLoading: false,
            actionType: props.evt.config.actions ? props.evt.config.actions[0].action : null,
            actionExtras: {
                ROLL: [],
                SURVEY: [],
                VOTE: [],
                BARRAGE: [],
                LUCKYMONEY: [],
            }

        }
    }
    componentDidMount() {
        const actionExtras = { ...this.state.actionExtras };
        findRollpools({ eventId: this.props.evt.header.id }).then(res => {
            if (res.code == 200) {
                actionExtras['ROLL'] = res.data;
                this.setState({
                    actionExtras: actionExtras
                })

            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

        findSurveys().then(res => {
            if (res.code == 200) {
                actionExtras['SURVEY'] = res.data;
                this.setState({
                    actionExtras: actionExtras
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

        findVotes().then(res => {
            if (res.code == 200) {
                actionExtras['VOTE'] = res.data;
                this.setState({
                    actionExtras: actionExtras
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

        findBarrageConfigs().then(res => {
            if (res.code == 200) {
                actionExtras['BARRAGE'] = res.data;
                this.setState({
                    actionExtras: actionExtras
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

        findLuckyMoneys({ eventId: this.props.evt.header.id }).then(res => {
            if (res.code == 200) {
                actionExtras['LUCKYMONEY'] = res.data;
                this.setState({
                    actionExtras: actionExtras
                })

            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

        isValidity('SENIORMEMBER', (vaild) => {
            this.setState({
                validity: vaild
            })
        })

    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                const {evt} = this.props;
                this.changeFormLoading(true)
                console.log(values)
                values.actions[0].action ? null : values.actions = [];
                if(this.state.actionType == 'CUSTOM_URL'){
                    let _fields  = evt.form.fields.filter(f=>values.actions[0].extra.fields.some(o=>o==f.id)).map(obj=>({Id:obj.id,name:obj.name}));
                     values.actions[0].extra.fields = JSON.stringify(_fields);
                }
                patchEventConfig(Object.assign({ id: this.props.evt.header.id }, values)).then(res => {
                    console.log("updateEventConfig res: ", res);
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    render() {
        const evt = this.props.evt;
        const { actionType } = this.state;

        const { getFieldDecorator, getFieldValue, getFieldsValue, getFieldError, setFieldsValue } = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={() => {
                this.state.validity ? this.intoEdit() : this.pstView.show()
            }}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{ padding: "16px" }}>
                        {editableTools}

                        <CkInfoItem
                            label={<span>签到成功后跳转&nbsp;

                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                    mouseEnterDelay={0.3} title={
                                        <div>
                                            参与人自助扫码签到完成后，可以设置后跳转动作，支持自动跳转，默认是签到成功页面 <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/779712" target="_Blank" >  详细帮助</a>
                                        </div>
                                    }>
                                    <Icon type="question-circle-o" />
                                </Tooltip>
                            </span>}
                        >
                            {
                                this.props.editable ?
                                    <div>
                                        <div style={{ width: '50%' }}>
                                            {getFieldDecorator('actions[0].action', {
                                                initialValue: this.state.actionType,
                                                rules: [
                                                    { required: false, message: '请选择签到动作!', whitespace: true },
                                                ],
                                            })(
                                                <Select
                                                    onChange={(val) => {
                                                        this.setState({ actionType: val });
                                                        let value = getFieldsValue();
                                                        value.actions[0].extra.Id = null;
                                                        setFieldsValue(value);
                                                    }}
                                                >
                                                    <Select.Option value={null}>默认签到成功页面</Select.Option>
                                                    {
                                                        Object.values(this.props.cmEnums.data.PostCheckinActionType).map((item, index) => {
                                                            return <Select.Option value={item.enumName.toString()} key={`checkin-type-${index}`}>{item.enumDesc}</Select.Option>
                                                        })
                                                    }
                                                </Select>
                                            )}
                                        </div>
                                        <div style={{ display: 'none' }}>
                                            {getFieldDecorator('actions[0].extra.eventId', {
                                                initialValue: evt.header.id,
                                            })(
                                                <Input />
                                            )}
                                            {getFieldDecorator('actions[0].extra.userId', {
                                                initialValue: this.props.loginedUser.data.id,
                                            })(
                                                <Input />
                                            )}
                                        </div>

                                    </div>
                                    :
                                    evt.config.actions ? (evt.config.actions.map(obj => {
                                        return this.props.cmEnums.data.PostCheckinActionType[obj.action].enumDesc
                                    })) : "默认签到结果页面"
                            }
                        </CkInfoItem>
                        {this.props.editable && this.state.actionType && this.state.actionType != 'SIGNINDESC' && this.state.actionType != 'CONFIRMATION_LETTER' &&
                            <CkInfoItem labelStyle={{ display: 'none' }}>
                                {this.state.actionType == 'CUSTOM_URL' ?
                                    <div style={{ width: '50%', }}>
                                        {getFieldDecorator('actions[0].extra.customUrl', {
                                            initialValue: evt.config.actions && evt.config.actions[0].extra ? evt.config.actions[0].extra.customUrl : null,
                                            rules: [
                                                { required: true, message: '请输入!', },
                                                {
                                                    type: "string",
                                                    pattern: '^(https?)://[a-zA-Z0-9]+[a-zA-Z0-9.:&@#/%?=_]*',
                                                    message: '网址格式不正确!'
                                                }
                                            ],
                                        })(
                                            <Input placeholder="链接地址,如：http://www.qdj8.cn/" />
                                        )}
                                    </div>
                                    :
                                    (this.state.actionType != 'SIGNINDESC' &&
                                        <div style={{ width: '50%' }}>
                                            {getFieldDecorator('actions[0].extra.Id', {
                                                initialValue: evt.config.actions && evt.config.actions[0].extra ? evt.config.actions[0].extra.Id : null,
                                                rules: [
                                                    { required: true, message: '请选择!', whitespace: true },
                                                ],
                                            })(
                                                <Select
                                                    placeholder="请选择"
                                                >
                                                    {
                                                        this.state.actionExtras[this.state.actionType].map((item, index) => {
                                                            let name;
                                                            if (actionType == 'ROLL') {
                                                                name = item.poolName
                                                            } else if (actionType == 'SURVEY' || actionType == 'VOTE' || actionType == 'LUCKYMONEY') {
                                                                name = item.name;
                                                            } else if (actionType == 'BARRAGE') {
                                                                name = item.title;
                                                            }
                                                            return <Select.Option value={item.id}
                                                                key={index}>
                                                                {name}
                                                            </Select.Option>
                                                        })
                                                    }
                                                </Select>
                                            )}
                                        </div>)
                                }
                            </CkInfoItem>}

                        {this.props.editable && this.state.actionType && this.state.actionType == 'CUSTOM_URL' &&
                            <CkInfoItem labelStyle={{ display: 'none' }}>
                                <div style={{ width: '50%', }}>
                                    {getFieldDecorator('actions[0].extra.fields', {
                                        initialValue: evt.config.actions && evt.config.actions[0].extra ? (evt.config.actions[0].extra.fields ? JSON.parse(evt.config.actions[0].extra.fields).map(f=>f.Id) : []) : [],
                                        rules: [
                                            { required: false, message: '请选择!', },

                                        ],
                                    })(
                                        <Select
                                            mode='multiple'
                                            placeholder="请选择传递参数"
                                        >
                                            {
                                                evt.form.fields.filter(f => f.type == 'TEXT' && !lodash.startsWith(f.constraint, "img")).map((obj, index) => (
                                                    <Select.Option value={obj.id} key={index}>
                                                        {obj.name}
                                                    </Select.Option>
                                                ))
                                            }

                                        </Select>
                                    )}
                                </div>
                            </CkInfoItem>}
                        {this.props.editable && this.state.actionType &&
                            <CkInfoItem labelStyle={{ display: 'none' }}>
                                <div style={{ width: '50%', }}>
                                    {getFieldDecorator('actions[0].desc', {
                                        initialValue: evt.config.actions ? evt.config.actions[0].desc : null,
                                        rules: [
                                            { required: false, message: '请输入!', },

                                        ],
                                    })(
                                        <Input placeholder="描述，如：签到家官网" />
                                    )}
                                </div>
                            </CkInfoItem>}

                        {this.props.editable && this.state.actionType &&
                            <CkInfoItem label={'开启自动跳转'}>
                                <div style={{ width: '50%', }}>
                                    {getFieldDecorator(`postCheckinActionOpen`, {
                                        initialValue: evt.config.postCheckinActionOpen,
                                        valuePropName: 'checked',
                                        rules: [{ required: false }],
                                    })(
                                        <Switch checkedChildren={"开启"} unCheckedChildren={"关闭"} />
                                    )}
                                </div>
                            </CkInfoItem>}

                    </Card>
                </Spin>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}
                />
            </Form>
        )
    }
}


EvtViewCheckinAction.contextTypes = {}

EvtViewCheckinAction.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "checkinAction",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewCheckinAction.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinAction));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinAction.jsx